import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import Button from '../Button/Button';
import { Label } from '../Label/Label';
import { CloseIcon } from '../../../lib/icons/CloseIcon';
import { ATTRIBUTES } from '../../../lib/constants/attributes';
import { COMMON_LABELS } from '../../../lib/constants/labelKeys';
import { useAttributeLabel } from '../../../lib/hooks/labels';
import { PureSeparator } from '../../app/compound/Separator/Separator';
import { classes } from '../../../lib/utils/cssUtils';
import { ConfirmDialogProps } from './ConfirmDialogTypes';
import styles from './ConfirmDialog.module.scss';
import { confirmDialogIds } from '../../../lib/tests/testIds';
import RefreshLoader from '../RefreshLoader/RefreshLoader';

export const ConfirmDialog = ({
  onConfirm,
  labelKeys,
  isOpen,
  onCancel,
  children,
  dialogTitle,
  confirmButtonStatus = 'enabled',
}: ConfirmDialogProps) => {
  const closeBtnAriaLabel = useAttributeLabel(ATTRIBUTES.ARIA_LABEL, COMMON_LABELS.DIALOG.CLOSE);

  return (
    <Dialog open={isOpen} onClose={onCancel} classes={{ root: styles.dialogRoot, paper: styles.dialogMainContainer }}>
      <div className={styles.titleRow}>
        <DialogTitle className={styles.dialogTitle}>
          {dialogTitle ?? (!!labelKeys.dialogTitle && <Label name={labelKeys.dialogTitle} />)}
        </DialogTitle>
        <button className={styles.closeIcon} onClick={onCancel} {...closeBtnAriaLabel}>
          <CloseIcon variant="secondary" />
        </button>
      </div>
      <PureSeparator className={styles.dialogSeparator} asDiv={undefined} />
      <DialogContent classes={{ root: styles.dialogContent }}>
        {children}
        {!!labelKeys.content && (
          <div className={styles.dialogInsideContainer}>
            <Label name={labelKeys.content} />
          </div>
        )}
      </DialogContent>
      <DialogActions classes={{ root: styles.dialogActions }}>
        <div className={styles.dialogActionsButtons}>
          <Button
            variant="outlined"
            className={classes(styles.dialogActionButton, styles.dialogActionButtonCancel)}
            onClick={onCancel}
            data-testid={confirmDialogIds.cancelButtonLabelKey}
          >
            <Label name={COMMON_LABELS.DIALOG.CANCEL} />
          </Button>
          <Button
            className={classes(styles.dialogActionButton)}
            onClick={onConfirm}
            data-testid={confirmDialogIds.confirmButtonLabelKey}
            disabled={confirmButtonStatus !== 'enabled'}
          >
            {confirmButtonStatus === 'loading' && <RefreshLoader />}
            <Label name={labelKeys.confirmButton} />
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};
